import CartStore from '@theme/cart-store';
import CartDrawer from '@theme/cart-drawer';
import CartModal from '@theme/cart-notification-modal';
import { resolveCartBehavior } from '@theme/cart-behavior';

let cartModuleRegistered = false;

// Intercept clicks on cart links to open drawer instead
// This runs immediately, before Alpine initializes
function interceptCartLinks() {
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href*="/cart"]');
    if (!link || !link.href) {
      return;
    }
    const cartIconBehavior =
      window.__AGENCY_CART?.settings?.cartIconBehavior || 'open_cart_drawer';
    if (
      resolveCartBehavior(
        window.__AGENCY_CART?.settings || {},
        window.innerWidth,
      ) === 'kaching_cart' ||
      cartIconBehavior === 'go_to_cart'
    ) {
      return;
    }
    try {
      const url = new URL(link.href);
      // Only intercept if it's going to /cart (not /cart/add or other cart routes)
      if (url.pathname === '/cart' || url.pathname.endsWith('/cart')) {
        event.preventDefault();
        event.stopPropagation();
        // Open the drawer
        document.dispatchEvent(
          new CustomEvent('cart:open', { detail: { trigger: link } }),
        );
        return false;
      }
    } catch (e) {
      // If URL parsing fails, check if href contains /cart
      if (link.href.includes('/cart') && !link.href.includes('/cart/add')) {
        event.preventDefault();
        event.stopPropagation();
        document.dispatchEvent(
          new CustomEvent('cart:open', { detail: { trigger: link } }),
        );
        return false;
      }
    }
  }, true); // Use capture phase to catch early
}

// Initialize cart link interception immediately
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', interceptCartLinks);
} else {
  interceptCartLinks();
}

function registerCartModule() {
  if (cartModuleRegistered || !window.Alpine) {
    return;
  }
  cartModuleRegistered = true;

  // Register Global Store
  window.Alpine.store('cart', CartStore);
  const cartStore = window.Alpine.store('cart');
  cartStore.ensureCompareAtPrices(cartStore.cart.items);

  // Register Component Logic
  window.Alpine.data('cartDrawer', CartDrawer);
  window.Alpine.data('cartModal', CartModal);

  // Listen for cart:item:added event (dispatched by ajax-product-forms.js and cart-store.js)
  // Handle based on cart behavior setting
  document.addEventListener('cart:item:added', (event) => {
    const store = window.Alpine.store('cart');
    if (store) {
      const behavior = resolveCartBehavior(
        window.__AGENCY_CART?.settings || {},
        window.innerWidth,
      );

      switch (behavior) {
        case 'modal':
          // Open the modal with the added item
          document.dispatchEvent(new CustomEvent('cart:modal:open', {
            detail: event.detail
          }));
          break;
        case 'alert':
          {
            const itemAdded = window.__AGENCY_CART?.strings?.itemAdded?.trim();
            if (itemAdded) {
              window.alert(itemAdded);
            } else {
              document.dispatchEvent(new CustomEvent('cart:open'));
            }
          }
          break;
        case 'redirect':
          window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
          break;
        case 'kaching_cart':
          // Cart UI is handled by the Kaching Cart app — keep cart count in sync only
          break;
        case 'drawer':
        default:
          // Open the drawer
          document.dispatchEvent(new CustomEvent('cart:open'));
          break;
      }
    }
  });
}

// Register on alpine:init event (fires when Alpine initializes)
document.addEventListener('alpine:init', registerCartModule);

// Fallback: If Alpine is already available, register immediately
if (window.Alpine) {
  registerCartModule();
}

